<template>
  <v-card class="ml">
    <div style="display: none">
      <EditDialog
          v-bind:model="showAddReport"
          v-bind:moduleName="'preventive_maintenances'"
          v-bind:btnName="''"
          v-bind:smallWidth="true"
          v-bind:formTitle="$t('add_item') +': ' +this.producer_name"
          @save="saveAddReportEvent"
          @close="cleanupAddReportDialog"
          ref="editDialogAddReport"
          >
          <template v-slot:edit_content>
            <!--- refacto into form ?--->
      <v-form ref='form'>
        <VueDatePicker
            v-model="editedItem.done_at"
            :teleport="true"
            :enable-time-picker="false"
            :rules="[v => !!v || $filters.capitalize($t('generic.required') )]"
            format="yyyy-MM-dd"
            placeholder="Date"
            required
            />
            <v-select
                v-if='reportType=="bl"'
                :rules="[v => !!v || $filters.capitalize($t('generic.required') )]"
                v-model="editedItem.verif_subtype"
                :items="['skyvisor', 'jumelles']"
                />
                <v-file-input
                    v-model="report_file"
                    @update:modelValue="on_select_file"
                    :label="$filters.capitalize($t('verif_reports.report'))"
                    show-size
                    ></v-file-input>
                <v-textarea
                    v-model="editedItem.comment"
                    :rules="[v => (v || '' ).length <= 400 || $filters.capitalize($t('generic.max_chars', {count: 400})) ]"
                    counter
                    />
      </v-form>
          </template>
      </EditDialog>
    </div>
    <div class="ml__head">
      <div class="ml__head-text">
        <div class="ml__title">{{ producer_name }}</div>
        <div class="ml__sub">{{ $filters.capitalize($t(pageTitle)) }} · {{ maint_reports.length }} {{ $t('preventive_maintenances.report', maint_reports.length) }}</div>
      </div>
      <v-btn size="small" color="primary" variant="flat" prepend-icon="mdi-plus" :text="$t('add')" @click="openDialog" />
      <v-btn icon="mdi-close" variant="text" density="comfortable" @click="closeMe" :aria-label="$t('close')" />
    </div>
    <v-card-text class="ml__body">
      <div v-if="maint_reports.length <= 0" class="ml__empty">{{ $filters.capitalize($t('no_data_text')) }}</div>
      <table v-else class="ml-table">
        <thead>
          <tr>
            <th>{{ $filters.capitalize($t("preventive_maintenances.done_at")) }}</th>
            <th v-if='reportType=="bl"'>{{ $filters.capitalize($t("verif_reports.subtype")) }}</th>
            <th>{{ $filters.capitalize($t("verif_reports.comment")) }}</th>
            <th class="ml-table__actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="maint in maint_reports" :key="maint.pk">
            <td class="ml-table__date">{{ $filters.formatDate(maint.done_at) }}</td>
            <td v-if='reportType=="bl"'><v-chip size="x-small" variant="tonal">{{ maint.verif_subtype }}</v-chip></td>
            <td class="ml-table__muted">{{ maint.comment }}</td>
            <td class="ml-table__actions">
              <v-btn
                  v-if="maint.report"
                  size="small"
                  variant="text"
                  color="primary"
                  prepend-icon="mdi-file-pdf-box"
                  :text="$t('actions.download')"
                  @click="openLink(maint.report)"
                  />
              <v-btn
                  icon="mdi-delete-outline"
                  size="small"
                  variant="text"
                  color="error"
                  :aria-label="$t('actions.delete')"
                  @click="deleteItemBtn(maint)"
                  />
            </td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
  </v-card>
</template>

<script>
  import { alertPopup } from "@/functions";
  import EditDialog from "@/components/EditDialog";

  export default {
    props: {
      producer_id: {},
      producer_name: {},
      reportType: {},
    },
    components: {
      EditDialog,
    },
    emits: ['close'],
    inject: { dialogClose: { default: null } },
    mounted() {
      this.loadList()
    },
    computed: {
      editedItem: function () {
        return this.$store.getters.dataEdit(this.moduleName);
      },
      pageTitle: function() {
        switch (this.reportType) {
          case 'ac':
            return 'verif_reports.annual'
          case 'bl':
            return 'verif_reports.blades'
          case 'th':
            return 'verif_reports.thermal'
          case 'br':
            return 'verif_reports.blade_repairs'
        };

      }
    },

    methods: {
      loadList() {
        this.$store.dispatch(`${this.moduleName}/getItems`, {
          producer_id: this.producer_id,
          verif_type: this.reportType,
        }).then((reps)=>{
          this.maint_reports = reps
        })
      },
      deleteItem(id_) {
        return this.$store.dispatch(`${this.moduleName}/deleteItem`, id_);
      },

      deleteItemBtn(item) {
        var index = this.maint_reports.findIndex(
          (i) => i.pk === item.pk,
        );
        alertPopup(this.$t("dialog.delete_confirm")).then((result) => {
          if (result && this.maint_reports.splice(index, 1)) {
            this.deleteItem(item.pk);
          }
        });
      },

      openLink(url) {
        window.open(url, "_blank");
      },
      closeMe() {
        if (this.dialogClose) this.dialogClose()
        else this.$emit('close')
      },
      openDialog(){
        // set producer id and verif_type
        this.editedItem.producer_id = this.producer_id
        this.editedItem.verif_type = this.reportType
        this.editedItem.done_at = new Date()
        this.report_file = []
        this.showAddReport = true
      },
      on_select_file() {
        this.editedItem.report = this.report_file;
      },
      genFile(path) {
        const infos = this.editedItem.report_infos;
        return new File([path], infos.name, { type: infos.type });
      },
      async validate () {
        const { valid } = await this.$refs.form.validate()
        return valid
      },
      async saveAddReportEvent() {
        const isValid = await this.validate();
        if (!isValid) return


        this.editedItem.done_at = this.editedItem.done_at.toJSON().substring(0,10)
        const report = this.editedItem?.report?.[0] || null;
        this.$store
          .dispatch(`${this.moduleName}/addItem`, this.editedItem)
          .then((item) => {
            if (report) {
              this.$store
                .dispatch(`${this.moduleName}/sendFile`, {
                  pk: item.pk,
                  file: report,
                  name: report.name,
                }).then(()=>{
                  this.loadList()
                  this.$store.dispatch(`${this.moduleName}/cleanupEdit`);
                })
            } else {
              this.loadList()
              this.$store.dispatch(`${this.moduleName}/cleanupEdit`);
            }
          })
        this.$refs.editDialogAddReport.closeDialog();
      },
      cleanupAddReportDialog() {
        this.showAddReport = false;
        this.$store.dispatch(`${this.moduleName}/cleanupEdit`);
      },
    },

    data() {
      return {
        moduleName: "verif_reports",
        maint_reports: [],
        showAddReport: false,
        report_file: [],
      };
    },
  };
</script>
<style scoped>
.ml {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}
.ml__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 8px 10px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.ml__head-text {
  flex: 1 1 auto;
  min-width: 0;
}
.ml__title {
  font-weight: 700;
  font-size: 1.05rem;
  line-height: 1.25;
}
.ml__sub {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
}
.ml__body {
  overflow-y: auto;
  padding: 0;
}
.ml__empty {
  text-align: center;
  color: rgba(0, 0, 0, 0.55);
  padding: 24px 0;
}
.ml-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}
.ml-table th {
  padding: 8px 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(0, 0, 0, 0.55);
  text-align: left;
  background: #fafafa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.ml-table td {
  padding: 8px 12px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.ml-table tbody tr:hover {
  background: rgba(25, 118, 210, 0.05);
}
.ml-table__date {
  font-weight: 600;
  white-space: nowrap;
}
.ml-table__muted {
  color: rgba(0, 0, 0, 0.65);
}
.ml-table__actions {
  width: 1%;
  white-space: nowrap;
  text-align: right;
}
</style>
